import { useEffect, useMemo } from 'react';
import { TABLE_SCHEME_VARIABLES, TABLE_SCHEME_HEX_PATTERN } from '../constants/tableScheme';

/**
 * Filtert ein rohes `tableScheme`-Objekt auf bekannte Schluessel mit gueltigem Hex-Wert.
 * @param {Object|null|undefined} scheme
 * @returns {Object<string,string>} Map CSS-Variable -> Farbwert
 */
export function sanitizeTableScheme(scheme) {
  const result = {};
  if (!scheme || typeof scheme !== 'object') return result;
  Object.keys(TABLE_SCHEME_VARIABLES).forEach((key) => {
    const value = scheme[key];
    if (typeof value === 'string' && TABLE_SCHEME_HEX_PATTERN.test(value)) {
      result[TABLE_SCHEME_VARIABLES[key]] = value;
    }
  });
  return result;
}

/**
 * Setzt das tenantspezifische Tabellen-Farbschema als CSS-Variablen auf <html>. Fehlende oder
 * ungueltige Werte bleiben ungesetzt (Fallback: Defaults aus styles/tableScheme.css). Beim
 * Schemawechsel bzw. Unmount werden die gesetzten Properties wieder entfernt.
 *
 * @param {Object|null|undefined} tableScheme - `tableScheme` aus dem Tenant-Branding
 */
export default function useTenantTableScheme(tableScheme) {
  // Stabiler String-Schluessel (sortierte Eintraege), damit der Effekt nur bei inhaltlicher Aenderung laeuft.
  const key = useMemo(
    () => Object.entries(sanitizeTableScheme(tableScheme)).sort(([a], [b]) => a.localeCompare(b))
      .map(([name, value]) => `${name}=${value}`).join(';'),
    [tableScheme]
  );

  useEffect(() => {
    const names = [];
    const root = document.documentElement;
    key.split(';').filter(Boolean).forEach((entry) => {
      const [name, value] = entry.split('=');
      root.style.setProperty(name, value);
      names.push(name);
    });
    return () => names.forEach((name) => root.style.removeProperty(name));
  }, [key]);
}
